import { Component, OnInit } from "@angular/core";
import { MenuService } from "@app/shared/services/menu.service";
import { TitleService } from "@app/shared/services/title.service";
import { VehiclesService } from "@app/shared/services/vehicles.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from "@app/shared/services/alert.service";
import { PhotoService } from "@app/shared/services/photo.service";
import { StateOfCarService } from "@app/shared/services/state-of-car.service";
import { DateService } from "@app/shared/services/date.service";
import * as moment from "moment";
import { SessionService } from "@app/shared/services/session.service";
import { ReservationsService } from '@app/shared/services/reservations.service';

@Component({
    selector: "app-vehicle-informations",
    templateUrl: "./vehicle-informations.component.html",
    styleUrls: ["./vehicle-informations.component.scss"],
})
export class VehicleInformationsComponent implements OnInit {

    public id: string = "0";
    public vehicle: any = {};
    public states: Array<any> = [];
    public statesOfCar: Array<any> = [];
    public managerStatesOfCar: Array<any> = [];
    public loading: boolean = true;
    public loadingPhoto: boolean = false;
    public loadingState: boolean = true;
    public loadingStateOfCar: boolean = true;
    public loadingManagerStateOfCar: boolean = true;
    public stateNoResult: boolean = false;
    public archivedOnly: boolean = false;

    public maxPages: number = 1;
    public loadingStatus: boolean = true;
    public noResult: boolean = false;
    public reservations: any = [];
    public reservationsVenir: any = [];
    public reservationsDemarrer: any = [];

    public boundStateOfCar: any = {
        statesOfCar: []
    };
    public boundManagerState: any = {
        id: 0,
        relatedStates: []
    };
    public nextReservation: any = {
        reservation: {},
        state: 'no-reservation'
    }

    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private vehicleService: VehiclesService,
        private route: ActivatedRoute,
        private alertService: AlertService,
        private photoService: PhotoService,
        private stateOfCarService: StateOfCarService,
        private dateService: DateService,
        public session: SessionService,
        public reservationService: ReservationsService,
        private router: Router,
    ) { }

    public dateStart: string = moment().add(-30, 'days').format('DD/MM/YYYY').split('T')[0];
    public dateEnd: string = moment().add(30, 'days').format('DD/MM/YYYY').split('T')[0];

    public choix: number = 0;
    public status: number = 0;
    public search: string = '';
    public societySearch: string = '';

    public routerURL: string = '/ressource/vehicle/list';
    public previousUrlName: string = 'Liste des véhicules'

    ngOnInit() {
        this.route.queryParams
            .subscribe(params => {
                if (params.from) this.routerURL = params.from;
                if (params.name) this.previousUrlName = params.name;
            });

        this.id = this.route.snapshot.paramMap.get("id");
        this.titleService.setTitle(`Information sur le véhicule / VOP`);
        this.menu.setMenuState("ressource", "vehicle", "information");
        this.menu.id = this.id;
        this.loadInformations();
        // this.initReservations(0)
    }

    // getNextReservation() {
    //     this.reservationService.getVehicleReservation(this.vehicle.name).then((res) => {
    //         res = this.dateService.convertAlltoLocal(res);
    //         let ref: any = {};

    //         res.forEach((reservation) => {
    //             if (reservation.Status >= 3 && reservation.Status <= 10) {
    //                 ref = reservation;
    //                 this.nextReservation.state = 'in-progress';
    //             }
    //             if (reservation.Status <= 2
    //             && reservation.Status >= 0
    //             && moment().isBefore(moment(reservation.ISODateStart, 'YYYY-MM-DD'))
    //             && (Object.keys(ref).length === 0 || moment(ref.ISODateStart, 'YYYY-MM-DD').isAfter(moment(reservation.ISODateStart, 'YYYY-MM-DD')))) {
    //                 ref = reservation;
    //                 this.nextReservation.state = 'come-up';
    //             }
    //         });
    //         this.nextReservation.reservation = ref;
    //     });
    // }

    loadInformations() {
        this.loading = true;
        this.vehicleService.getVehicle(this.id).then((res) => {
            this.vehicle = res;

            this.initReservations(0)
            this.loading = false;
        });
        this.refreshStatesOfCar();
    }

    refreshStatesOfCar() {
        this.loadingState = true;
        this.stateNoResult = false;
        this.states = [];
        this.statesOfCar = [];
        this.managerStatesOfCar = [];
        this.loadingStateOfCar = true;
        this.loadingManagerStateOfCar = true;
        setTimeout(() => {
            this.updateStatesOfCar();
            this.updateManagerStateOfCar();
        }, 100);
    }

    modifyPhoto() {
        this.photoService.askFile().then((photo) => {
            this.photoService
                .modifyVehiclePhoto(parseInt(this.id, 10), photo)
                .then((res) => {
                    if (!res || res.success === false) return this.alertService.alert("Une erreur est survenue lors du changement de la photo.");

                    this.loadingPhoto = true;
                    this.vehicleService.getVehicle(this.id).then((res) => {
                        this.vehicle.vehiclePicture = res.vehiclePicture;
                        this.loadingPhoto = false;
                    });
                });
        });
    }

    updateVehicle() {
        this.vehicleService.updateVehicle(this.vehicle).then(() => {
            this.alertService.alert("Les modifications ont été effectuées.");
            sessionStorage.removeItem('VehicleList')
        });
    }

    updateStatesOfCar() {
        this.stateOfCarService
            .getStateOfCarByVehicle(parseInt(this.id, 10))
            .then((res) => {
                if (res.length !== 0) {
                    this.statesOfCar = res;
                }
                this.loadingStateOfCar = false;
                if (this.loadingManagerStateOfCar === false) {
                    this.loadingState = false;
                    this.buildStatesList();
                }
            });
    }

    updateManagerStateOfCar() {
        this.stateOfCarService
            .getManagerStateOfCarByVehicle(parseInt(this.id, 10))
            .then((res) => {
                if (res.length !== 0) {
                    this.managerStatesOfCar = res;
                }
                this.loadingManagerStateOfCar = false;
                if (this.loadingStateOfCar === false) {
                    this.loadingState = false;
                    this.buildStatesList();
                }
            });
    }

    groupManagerState() {
        let removedStates = [];

        this.managerStatesOfCar.forEach((manager) => {
            manager.relatedStates = [];
            if (manager.part !== 1) {
                return;
            }
            this.managerStatesOfCar.forEach((manager2) => {
                if (manager.idStateOfCar !== manager2.idStateOfCar
                    && moment(manager.ISOCreated).subtract(1, 'minute').isBefore(manager2.ISOCreated)
                    && moment(manager.ISOCreated).add(1, 'minute').isAfter(manager2.ISOCreated)) {
                    manager.relatedStates.push(manager2);
                    removedStates.push(manager2);
                }
            });
        });
        removedStates.forEach((removed) => {
            let index = this.managerStatesOfCar.indexOf(removed);
            this.managerStatesOfCar.splice(index, 1);
        });
    }

    groupStateOfCar() {
        let tmp: any = {};

        this.statesOfCar.forEach((state) => {
            if (typeof tmp[`idBooking+${state.idBooking}+${state.type}`] !== 'undefined') {
                tmp[`idBooking+${state.idBooking}+${state.type}`].statesOfCar.push(state);
            }
            if (typeof tmp[`idBooking+${state.idBooking}+${state.type}`] === 'undefined') {
                tmp[`idBooking+${state.idBooking}+${state.type}`] = {
                    statesOfCar: [state],
                    type: state.type,
                    imgs: [state.imgs[0]],
                    state: state.state,
                    ISOCreated: state.ISOCreated
                };
            }
        });
        this.statesOfCar = [];
        Object.keys(tmp).forEach((key) => {
            this.statesOfCar.push(tmp[key]);
        });
    }

    buildStatesList() {
        let i,
            j = 0;

        if (this.statesOfCar.length + this.managerStatesOfCar.length === 0) {
            this.stateNoResult = true;
        }
        this.groupManagerState();
        this.groupStateOfCar();
        this.managerStatesOfCar.forEach((manager) => {
            manager = this.dateService.convertToLocal(manager);
            manager.stateType = "manager";
            this.states.push(manager);
        });

        this.statesOfCar.forEach((state) => {
            state = this.dateService.convertToLocal(state);
            state.stateType = "state";
            this.states.push(state);
        });

        for (i = 0; i < this.states.length - 1; i++) {
            for (j = 0; j < this.states.length - i - 1; j++) {
                if (
                    moment(this.states[j].ISOCreated).isBefore(
                        this.states[j + 1].ISOCreated
                    ) === true
                ) {
                    [this.states[j], this.states[j + 1]] = [
                        this.states[j + 1],
                        this.states[j],
                    ];
                }
            }
        }
    }

    openVehicle() {
        this.vehicleService
            .command(this.vehicle.idEquipment, "opendoor")
            .then(() => {
                this.alertService.alert("Le véhicule est désormais ouvert.");
            });
    }

    closeVehicle() {
        this.vehicleService
            .command(this.vehicle.idEquipment, "closedoor")
            .then(() => {
                this.alertService.alert("Le véhicule est désormais fermé.");
            });
    }

    stopEngine() {
        this.vehicleService
            .command(this.vehicle.idEquipment, "enginestop")
            .then(() => {
                this.alertService.alert("Le moteur du véhicule est désormais coupé.");
            });
    }

    bindManagerState(managerState) {
        this.boundManagerState.id = managerState.idStateOfCar;
        this.boundManagerState.relatedStates = managerState.relatedStates;
    }

    bindSinister(sinister) {
        this.boundStateOfCar.statesOfCar = sinister.statesOfCar;
    }

    activateVehicle(action) {
        this.vehicleService.activateVehicle(parseInt(this.id, 10), action).then((res) => {
            this.loadInformations();
            this.alertService.alert((action === true) ? `Le véhicule est désormais activé.` : `Le véhicule est désormais désactivé.`);
            sessionStorage.removeItem('VehicleList')
        })
    }

    changeArchivedOnlyFilter(toggle) {
        this.archivedOnly = toggle;
    }

    getEtatgestionnaire(states): Array<any> {
        let filteredStates: Array<any> = [];

        filteredStates = states.filter(state => state.stateType === 'manager').filter(state => (state.stateType === 'manager' && state.state !== 1) || (state.stateType === 'state' && state.state !== 2))

        return filteredStates;
    }

    filterStates(states): Array<any> {
        // if (this.archivedOnly === true) {
        //     return states;
        // } else {
        //     let filteredStates : Array<any> = [];

        //     states.forEach((state) => {
        //         if ((state.stateType === 'manager' && state.state !== 1) || (state.stateType === 'state' && state.state !== 2)) {
        //             filteredStates.push(state);
        //         }
        //     });
        //     return filteredStates;
        // }

        // <span *ngIf="state.stateType === 'manager'" class="title">État gestionnaire</span>
        // <span *ngIf="state.stateType === 'state' && state.type === 0" class="title">État des lieux d'entrée</span>
        // <span *ngIf="state.stateType === 'state' && state.type === 1" class="title">Sinistres & États des lieux</span>
        // <span *ngIf="state.stateType === 'state' && state.type === 2" class="title">État des lieux de sortie</span>
        // let filteredStates : Array<any> = [];

        // if(this.choix === 0) //states.stateType === 'manager')
        // {
        //     return states;
        // }
        // else if(this.choix === 1) //states.stateType === 'state' && states.type === 0
        // {   
        //     return states.filter(state => state.stateType === 'manager')
        // }
        // else if(this.choix === 2)
        // {
        //     return states.filter(state => (state.stateType === 'state' && state.type === 0) || (state.stateType === 'state' && state.type === 2))
        // }
        // else if(this.choix === 3)
        // {
        //     return states.filter(state => state.stateType === 'state' && state.state === 1)
        // }
        // else if(this.choix === 4)
        // {
        //     return states.filter(state => (state.state === 2) || (state.stateType === "manager" && state.state === 1)) // || (state.stateType === 'state' && state.state !== 2)
        // }

        let filteredStates: Array<any> = [];

        if (this.choix === 0) //states.stateType === 'manager')
        {
            // filteredStates = states.filter(state => state.stateType === 'manager').filter(state => (state.stateType === 'manager' && state.state !== 1) || (state.stateType === 'state' && state.state !== 2))

            // filteredStates = filteredStates.concat(states.filter(state => (state.stateType === 'state' && state.type === 0)).filter(state => (state.stateType === 'manager' && state.state !== 1) || (state.stateType === 'state' && state.state !== 2)))
            filteredStates = states.filter(state => (state.stateType === 'state' && state.type === 2)).filter(state => (state.stateType === 'manager' && state.state !== 1) || (state.stateType === 'state' && state.state !== 2))
            return filteredStates;
        }
        else if (this.choix === 1) //states.stateType === 'state' && states.type === 0
        {
            // return states.filter(state => state.stateType === 'state' && state.type === 2)
            return states.filter(state => state.stateType === 'state' && state.type === 0).filter(state => (state.stateType === 'manager' && state.state !== 1) || (state.stateType === 'state' && state.state !== 2) || state.state === 2)
            // return states.filter(state => (state.stateType === 'state' && state.type === 0) || (state.stateType === 'state' && state.type === 2) || state.stateType === 'manager')
        }
        // else if(this.choix === 2)
        // {
        //     return states.filter(state => state.stateType === 'state' && state.type === 1)
        // }
        else if (this.choix === 2) {
            return states.filter(state => (state.stateType === "manager" && state.state === 1)) //(state.state === 2) || 
        }
    }

    redirectToReservationList() {
        sessionStorage.setItem('ReservationFilterSearch', this.vehicle.name);
        this.router.navigate(['/reservation/list']);
    }

    initReservations(next) {
        if (next === 390) {
            return;
        }

        this.reservationService.updateReservationByDate(
            moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
            moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
            1, this.status, this.vehicle.name, this.societySearch
        ).then((res) => {
            this.maxPages = this.reservationService.maxPages;
            if (res.length === 0) {
                this.noResult = true;
                this.dateStart = moment().subtract(next + 30, 'days').format('DD/MM/YYYY').split('T')[0];
                this.dateEnd = moment().subtract(next, 'days').format('DD/MM/YYYY').split('T')[0];
                this.initReservations(next + 30);
            } else {
                this.loadingStatus = false;
                this.noResult = false;
                res = this.dateService.convertAlltoLocal(res);
                this.reservations = res;
                this.reservationsDemarrer = this.reservations.filter(reservation => reservation.Status >= 3 && reservation.Status <= 10).slice(0, 5);
                this.reservationsVenir = this.reservations.filter(reservation => reservation.Status >= 0 && reservation.Status <= 2).slice(0, 5);
            }
        });
    }

    changeStatus(status): void {
        this.choix = status;
    }
}